import React from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import servicioHttp from '../servicio/ServicioHttp';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import servicioObjetos from '../servicio/ServicioObjetos';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';

const MENSAJE_REQUERIDO = "Información requerida";
export class SalarioMinimo extends React.Component {

    constructor() {
        super();
        this.state = {
            paginacion: { registrosPorPagina: 8 },
            mostrarDialogAgregar: false,
            mostrarDialogEditar: false,
            mostrarModalConfirmacion: false,
            ejercicio: {},
            errores: {},
            desarrollador: false,
            idsenube: 0
        };
    }

    componentDidMount() {
        this.salariosMinimos();
        this.obtnerUsuarioDesarrollador();
    }

    obtnerUsuarioDesarrollador = () => {
        servicioHttp.consumirPostHttp('usuario/obtener_usuario_sesion_perfil.json').then(response => {
            if (response.data.mensaje === "existe") {
                this.setState({ desarrollador: true });
            }
        }).catch(error => {
        });
    }

    salariosMinimos = () => {
        servicioHttp.consumirPostHttp("salario/consulta_salario_minimo.json").then(response => {
            this.setState({ paginacion: response.data.objeto });
        }).catch(error => {
        });
    }

    plantillaOpciones = (rowData, column) => {
        return <div className="p-grid">
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.actualizar(column.rowData)}
                    className="p-button-warning" name="editar" tooltip="Editar información de ejercicio">
                </Button>
            </div>
            <div className="p-col-12 p-md-6">
                <Button type="button" icon="pi-md-delete" onClick={(e) => this.mostrarModalEliminar(column.rowData)}
                    className="p-button-danger" name="eliminar" tooltip="Eliminar registro" >
                </Button>
            </div>
        </div>;
    }

    guardarSalario = () => {
        let { ejercicio } = this.state;
        let guardaSalario = { ...ejercicio };
        let validForm = this.validarFormulario(guardaSalario);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            guardaSalario.anio = ejercicio.anio;
            guardaSalario.vigencia = ejercicio.vigencia;
            guardaSalario.zonaA = ejercicio.zonaA;
            guardaSalario.zonaB = ejercicio.zonaB;
            guardaSalario.zonaC = ejercicio.zonaC;
            servicioHttp.consumirPostHttp("salario/guardar_salario_minimo.json", guardaSalario).then((response) => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalAgregar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    reset = () => {
        this.setState({
            ejercicio: {},
            errores: {}
        });
    }

    actualizar(objeto) {
        var ejercicioEditar = JSON.parse(JSON.stringify(objeto));
        this.setState({ mostrarDialogEditar: true, ejercicio: ejercicioEditar });
    }

    editarSalario = () => {
        let { ejercicio } = this.state;
        let validForm = this.validarFormulario(ejercicio);
        this.setState({ errores: validForm });
        if (!Object.keys(validForm).length) {
            servicioHttp.consumirPostHttp("salario/actualizar_salario_minimo.json", ejercicio).then(response => {
                this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                this.componentDidMount();
                this.cerrarModalEditar();
            }).catch(error => {
                return this.growl.show({ severity: 'error', summary: '', detail: 'Se generó un error inesperado!!!, por favor inténtelo de nuevo' });
            })
        }
    }

    eliminar = () => {
        let { ejercicio } = this.state;
        servicioHttp.consumirPostHttp("salario/salario_eliminar.json", ejercicio).then(response => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.componentDidMount();
            this.cerrarModalEliminar();
        }).catch(error => {
            return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        })

    }

    validarFormulario = (ejercicio) => {
        let errores = {};

        if (servicioObjetos.esObjetoVacio(ejercicio.anio)) {
            errores.anio = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(ejercicio.vigencia)) {
            errores.vigencia = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(ejercicio.zonaA)) {
            errores.zonaA = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(ejercicio.zonaB)) {
            errores.zonaB = MENSAJE_REQUERIDO;
        }
        if (servicioObjetos.esObjetoVacio(ejercicio.zonaC)) {
            errores.zonaC = MENSAJE_REQUERIDO;
        }
        return errores;
    }

    asignaValor = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    };

    mostrarModalAgregar = () => {
        this.setState({ mostrarDialogAgregar: true });
    };

    cerrarModalAgregar = () => {
        this.setState({
            mostrarDialogAgregar: false
        });
        this.reset();
    }

    mostrarModalEditar = () => {
        this.setState({ mostrarDialogEditar: true });
    };

    cerrarModalEditar = () => {
        this.setState({
            mostrarDialogEditar: false
        });
        this.reset();
    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalConfirmacion: true, ejercicio: objeto });
    }

    cerrarModalEliminar = () => {
        this.setState({ mostrarModalConfirmacion: false });
        this.reset();
    }

    render() {
        let { paginacion, mostrarDialogAgregar, ejercicio, errores, mostrarDialogEditar, mostrarModalConfirmacion, desarrollador } = this.state;
        let pieTablaBotones = <div className="p-fluid p-grid">
            <div className="p-col-12 p-md-3">
                {desarrollador ?
                    <Button className="p-button-secondary" type="button" name="agregarEjercicio" label="Agregar ejercicio" icon="pi-md-plus" tooltip="Agregar ejercicio" onClick={this.mostrarModalAgregar}></Button>
                    : null}
            </div>
        </div>;

        const pieDialogoExaminar = (
            <div>
                <Button icon="pi-md-save" onClick={this.guardarSalario} label="Guardar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalAgregar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogo = (
            <div>
                <Button icon="pi-md-check" onClick={this.editarSalario} label="Aceptar" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEditar} label="Cancelar" className="p-button-danger flat-btn" />
            </div>
        );

        const pieDialogEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" />
                <Button icon="pi-md-close" onClick={this.cerrarModalEliminar} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );

        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="card card-w-title">
                    <div className="p-fluid p-grid">
                        <div className="p-col-12 p-md-12">
                            <h1>SALARIOS MÍNIMOS</h1>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <DataTable header="SALARIOS MÍNIMOS" selectionMode="single" responsive={true} >
                                <Column header="" autolayout={true} style={{ width: '390px' }} />
                                <Column header="ÁREA GEOGRÁFICA" autolayout={true} style={{ width: '120px' }} />
                                <Column header="" autolayout={true} style={{ width: '200px' }} />
                            </DataTable>
                            <DataTable footer={pieTablaBotones} value={paginacion.datos} responsive={true} paginator={true} rows={8}>
                                <Column header="AÑO" field="anio" autolayout={true} style={{ width: '40px' }} />
                                <Column header="VIGENCIA" field="vigencia" autolayout={true} style={{ width: '80px' }} />
                                <Column header="A" field="zonaA" autolayout={true} style={{ width: '40px' }} />
                                <Column header="B" field="zonaB" autolayout={true} style={{ width: '40px' }} />
                                <Column header="C" field="zonaC" autolayout={true} style={{ width: '40px' }} />
                                {desarrollador === true ?
                                    <Column header="OPCIONES" body={this.plantillaOpciones} autolayout={true} style={{ width: '20px' }} />
                                    : null}
                            </DataTable>
                        </div>
                        <Dialog style={{ width: '60%', height: '40%' }} appendTo={document.body} header="Agregar registro - Salario Mínimo" visible={mostrarDialogAgregar}
                            modal={true} onHide={this.cerrarModalAgregar} footer={pieDialogoExaminar}>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-1">
                                    <label style={{ width: "50%" }}><strong>Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.anio" name="ejercicio.anio" value={ejercicio.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="Año" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="4" keyfilter="pint" style={{ width: "100%" }} />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>

                                <div className="p-col-12 p-md-1">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label style={{ width: "30%" }}><strong>Vigencia:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.vigencia" name="ejercicio.vigencia" value={ejercicio.vigencia || ""}
                                        className={errores.vigencia ? "p-error" : ""} placeholder="DD/MM AL DD/MM" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="20" style={{ width: "100%" }} />
                                    {errores.vigencia ? <Message severity="error" text={errores.vigencia} /> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "100%" }}><strong>Área Geográfica:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaA" name="ejercicio.zonaA" value={ejercicio.zonaA || ""}
                                        className={errores.zonaA ? "p-error" : ""} placeholder="zona A" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaA ? <Message severity="error" text={errores.zonaA} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaB" name="ejercicio.zonaB" value={ejercicio.zonaB || ""}
                                        className={errores.zonaB ? "p-error" : ""} placeholder="zona B" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaB ? <Message severity="error" text={errores.zonaB} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaC" name="ejercicio.zonaC" value={ejercicio.zonaC || ""}
                                        className={errores.zonaC ? "p-error" : ""} placeholder="zona C" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaC ? <Message severity="error" text={errores.zonaC} /> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                            </div>
                        </Dialog>

                        <Dialog style={{ width: '60%', height: '40%' }} appendTo={document.body} header="Editar registro - Salario Mínimo" visible={mostrarDialogEditar}
                            modal={true} onHide={this.cerrarModalEditar} footer={pieDialogo}>
                            <div className="p-grid">

                                <div className="p-col-12 p-md-1">
                                    <label style={{ width: "50%" }}><strong>Año:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.anio" name="ejercicio.anio" value={ejercicio.anio || ""}
                                        className={errores.anio ? "p-error" : ""} placeholder="Año" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="4" keyfilter="pint" style={{ width: "100%" }} />
                                    {errores.anio ? <Message severity="error" text={errores.anio} /> : null}
                                </div>

                                <div className="p-col-12 p-md-1">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-2">
                                    <label style={{ width: "30%" }}><strong>Vigencia:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.vigencia" name="ejercicio.vigencia" value={ejercicio.vigencia || ""}
                                        className={errores.vigencia ? "p-error" : ""} placeholder="DD/MM AL DD/MM" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="20" style={{ width: "100%" }} />
                                    {errores.vigencia ? <Message severity="error" text={errores.vigencia} /> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>

                                <div className="p-col-12 p-md-3">
                                    <label style={{ width: "100%" }}><strong>Área Geográfica:</strong></label>
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaA" name="ejercicio.zonaA" value={ejercicio.zonaA || ""}
                                        className={errores.a ? "p-error" : ""} placeholder="zona A" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaA ? <Message severity="error" text={errores.zonaA} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaB" name="ejercicio.zonaB" value={ejercicio.zonaB || ""}
                                        className={errores.zonaB ? "p-error" : ""} placeholder="zona B" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaB ? <Message severity="error" text={errores.zonaB} /> : null}
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <InputText id="ejercicio.zonaC" name="ejercicio.zonaC" value={ejercicio.zonaC || ""}
                                        className={errores.c ? "p-error" : ""} placeholder="zona C" onChange={(e) => this.asignaValor(e, true)}
                                        maxLength="10" keyfilter="num" style={{ width: "100%" }} />
                                    {errores.zonaC ? <Message severity="error" text={errores.zonaC} /> : null}
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>
                            </div>
                        </Dialog>
                        <Dialog style={{ width: '50%', height: '30%' }} header="Eliminar registro - Salario Mínimo" visible={mostrarModalConfirmacion} modal={true}
                            footer={pieDialogEliminar} onHide={this.cerrarModalEliminar}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    <center><h2><strong>¿Estás seguro de eliminar este registro?</strong></h2></center>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </div>
        );
    }
}